angular.module('main').filter(
	'cutEmail',
	() =>
		function(value) {
			if (!value) {
				return '';
			}
			const max = 15;
			if (value.length <= max) {
				return value;
			}
			value = value.substr(0, max);
			return `${value}...`;
		}
);



// WEBPACK FOOTER //
// ./web/js/services/filters/cutEmailFilter.js